import axios, {AxiosResponse} from 'axios'
import {ApiResponse, PageResponse} from '../../../shared/models/ApiModels'
import { IRentFilterModel, IRentModel } from './RentModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const RENT_CREATE_URL = `${API_URL}api/v1/rent/create`
export const RENT_GET_ALL_URL = `${API_URL}api/v1/rent/all`
export const RENT_DELETE_URL = `${API_URL}api/v1/rent/delete/`
export const RENT_UPDATE_URL = `${API_URL}api/v1/rent/update/`
export const RENT_FILTER_URL = `${API_URL}api/v1/rent/filter`
export const RENT_GET_BY_ID_URL = `${API_URL}api/v1/rent/getById/`

export function getRentById(
  id: string
): Promise<AxiosResponse<ApiResponse<IRentModel>>> {
  return axios.get(RENT_GET_BY_ID_URL + encodeURIComponent(id))
}

export function createRent(values: IRentModel) {
  const payload: IRentModel = {
    ...values,
    additionalServices: values.additionalServices
      ? values.additionalServices.filter((s) => s.isAdd)
      : null,
  }

  return axios.post(RENT_CREATE_URL, payload)
}

export function loadRents(page = 0) {
  return axios.get(RENT_GET_ALL_URL, {params: {page, size: 10}})
}

export async function filterRents(
  rentFilter: IRentFilterModel,
  page = 0,
  size = 5,
  sort: string = 'createdDate',
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IRentModel>>>> {
  return axios.post(RENT_FILTER_URL, rentFilter, {
    params: {page, size, sort, order},
  })
}

export function deleteRent(rentId: String) {
  return axios.post(RENT_DELETE_URL + rentId)
}

export function updateRent(rentId: String, rent: IRentModel) {
  return axios.post(RENT_UPDATE_URL + rentId, rent)
}
